import React, { Component } from "react";

import GenericExpandingBox from "components/ExpandingBox";

export default class ExpandingBox extends Component {
  
  // Copy generic Header and Body sub-components
  static Header = GenericExpandingBox.Header;
  static Body = GenericExpandingBox.Body;
  
  render() {
    return (
      <GenericExpandingBox cssModifier="teachers" {...this.props}>
        {this.props.children}
      </GenericExpandingBox>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/teachers/ExpandingBox.js